import {
  Box,
  CircularProgress,
  IconButton,
  Menu,
  MenuItem,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { imageStudioActions } from "store/imageStudio";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { addDoc, collection, deleteDoc, doc } from "firebase/firestore";
import { db } from "firebaseApp";
import { useTheme } from "@emotion/react";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

export default function ImageGeneration({
  imageGeneration,
  onClick = (imageGeneration) => {},
  size = 200,
  showMenu = true,
  menuItems = [],
}) {
  const dispatch = useDispatch();

  const theme = useTheme();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setConfirmingDelete(false);
  };

  const [confirmingDelete, setConfirmingDelete] = useState(false);

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = imageGeneration.image.imageUrl;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    handleClose();
  };

  const handleRetry = async () => {
    const { id, error, generating, ...data } = imageGeneration;
    await addDoc(collection(db, "imageGeneration"), {
      ...data,
      generating: true,
    });
    await deleteDoc(doc(db, "imageGeneration", id));
    handleClose();
  };

  const handleDelete = () => {
    if (confirmingDelete) {
      deleteDoc(doc(db, "imageGeneration", imageGeneration.id));
      handleClose();
    } else {
      setConfirmingDelete(true);
    }
  };

  const handleAction = (menuItem) => {
    if (menuItem.action) {
      menuItem.action(imageGeneration);
    }
    if(!menuItem.noClose) {
      handleClose();
    }
  };

  return (
    <Paper>
      <Stack
        sx={{
          width: `${size}px`,
          height: `${size}px`,
          position: "relative",
        }}
      >
        <IconButton
          onClick={handleClick}
          sx={{
            position: "absolute",
            top: 4,
            right: 4,
          }}
        >
          <MoreVertIcon />
        </IconButton>
        {imageGeneration?.image?.imageUrl && (
          <Box
            onClick={() => onClick(imageGeneration)}
            component="img"
            src={imageGeneration.image.imageUrl}
            alt="preview"
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
          />
        )}
        {imageGeneration.generating && (
          <Stack
            alignItems="center"
            justifyContent="center"
            spacing={1}
            sx={{
              height: "100%",
              width: "100%",
            }}
          >
            <Typography>Generating</Typography>
            <CircularProgress />
          </Stack>
        )}
        {imageGeneration?.error && (
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            spacing={1}
            sx={{
              height: "100%",
              width: "100%",
            }}
          >
            <ErrorOutlineIcon color="error" />

            <Typography
              sx={{
                color: theme.palette.text.main,
              }}
              variant="caption"
            >
              <b>Error: </b>
              {imageGeneration.error}
            </Typography>
          </Stack>
        )}
      </Stack>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {menuItems.map((menuItem) => (
          <MenuItem key={menuItem.label} onClick={() => handleAction(menuItem)}>
            {menuItem.label}
          </MenuItem>
        ))}
        <MenuItem
            sx={{ color: theme.palette.error.main }}
            variant="error"
            onClick={handleDelete}
          >
            {confirmingDelete ? "Are you sure?" : "Delete"}
          </MenuItem> 
        {/*
          {imageGeneration.image && (
            <MenuItem onClick={handleEdit}>Edit</MenuItem>
          )}
          {imageGeneration.image && (
            <MenuItem onClick={handleEditWithPrompt}>Edit with prompt</MenuItem>
          )}
          {imageGeneration.image && (
            <MenuItem onClick={handleUserPrompt}>Use prompt</MenuItem>
          )}
          {!imageGeneration.image && (
            <MenuItem onClick={handleRetry}>Retry</MenuItem>
          )}
          <MenuItem
            sx={{ color: theme.palette.error.main }}
            variant="error"
            onClick={handleDelete}
          >
            {confirmingDelete ? "Are you sure?" : "Delete"}
          </MenuItem> */}
      </Menu>
    </Paper>
  );
}
